import { useTranslation } from "react-i18next";
import Typewriter from "typewriter-effect";

const TypewriterWelcome = () => {
  const { t } = useTranslation(["chatPage"]);
  return (
    <div className="mb-10 flex justify-center">
      <div className="text-center font-bold text-2xl ">
        <Typewriter
          onInit={(typewriter) => {
            typewriter.pauseFor(200).typeString(t("typewriterMessage")).start();
          }}
          options={{
            delay: 30,
            skipAddStyles: true,
            cursorClassName: "hidden",
          }}
        />
      </div>
    </div>
  );
};

export { TypewriterWelcome };
